import { FormInput, FormSelect, Patterns, spreadAndtransformDefaultValues } from "@common/components/forms";
import { useApp } from "@common/hooks";
import { IStoreSearchFilter } from "@common/stores/search";
import { find } from "lodash";
import { observer } from "mobx-react";
import React from "react";
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

interface LocationFilterProps {
    filter: IStoreSearchFilter,
    defaultFilter: IStoreSearchFilter,
    onApplyFilter: (filter: IStoreSearchFilter) => void
    onClearFilter: () => void;
}

export const LocationsFilter = observer((props: LocationFilterProps) => {
    const { configuration } = useApp();

    const { register, handleSubmit, control, reset } = useForm<IStoreSearchFilter>({
        shouldFocusError: true,
        defaultValues: spreadAndtransformDefaultValues(props.filter)
    });

    /**
     * Clear all existing filters and resets form
     */
    const removeAllFilters = () => {
        props.onClearFilter()
        reset(spreadAndtransformDefaultValues(props.defaultFilter))
    }

    return (
        <Form onSubmit={handleSubmit(props.onApplyFilter)}>
            <div className="mb-3">
                <FormInput label="Location Name" fieldName="name" control={control} placeholder="Type location name" />
            </div>
            <div className="mb-3">
                <FormInput label="City" fieldName="city" control={control} placeholder="Type city" />
            </div>
            <div className="mb-3">
                <FormSelect label="State" fieldName="state" control={control}
                    isRequired={false}
                    options={configuration.states}
                    getOptionLabel={s => s.name}
                    getOptionValue={s => s.name}
                    mapOptionToValue={opt => opt?.name}
                    mapValueToOption={name => find(configuration.states, { name })}
                />
            </div>
            <div className="mb-3">
                <FormInput label="Zip Code" fieldName="zipCode" control={control} placeholder="Type zip code" rules={{ pattern: Patterns.zipCodeAny }} />
            </div>

            <Form.Group className="mb-3" controlId="isHospital">
                <Form.Check {...register('isHospital')} type="checkbox" label="Hospitals Only" />
            </Form.Group>

            <Form.Group>
                <Button className="sideBarButton" variant="primary" type="submit">
                    Filter
                </Button>
                <Button className="sideBarButton" variant="outline-primary" onClick={removeAllFilters}>
                    Remove All Filters
                </Button>
            </Form.Group>
        </Form>
    )
});
